import {Component, Input, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import {ChangePasswordService} from '../../../../services/change-password.service';

@Component({
  selector: 'app-insert-password-modal',
  templateUrl: './insert-password-modal.component.html',
  styleUrls: ['./insert-password-modal.component.css']
})
export class InsertPasswordModalComponent implements OnInit {

  @Input() modalTitle;
  objInitialState;

  passwordForm: FormGroup;
  itemSaved: Subject<boolean>;

  errorMessage = '';
  successMessage = '';

  submitted = false;

  get formData() { return this.passwordForm.controls; }

  constructor(public bsModalRef: BsModalRef, private formBuilder: FormBuilder, private changePwdService: ChangePasswordService) { }

  ngOnInit() {
    this.itemSaved = new Subject();
    this.createForm();
  }

  createForm() {
    this.passwordForm = this.formBuilder.group({
      passwordHash: [null, [Validators.required, Validators.maxLength(100)]]
    })
  }

  onSubmit() {
    this.submitted = true;
    this.errorMessage = '';
    this.successMessage = '';
    const param = {
      username: this.objInitialState.user.logon,
      currentPassword: this.formData.passwordHash.value,
      newPassword: this.objInitialState.values.workflowPasswordFields.passwordHash,
      confirmNewPassword: this.objInitialState.values.workflowPasswordFields.passwordRetype,
      crivoUser: this.objInitialState.values.crivoPasswordFields.crivoUser || '',
      crivoPassword: this.objInitialState.values.crivoPasswordFields.crivoPassword,
      crivoPasswordRetype: this.objInitialState.values.crivoPasswordFields.crivoPasswordRetype
    };

    this.changePwdService.savePassword(param).subscribe(res=> {
        this.successMessage = 'Alteração realizada com sucesso!';
        this.itemSaved.next(true);
        this.passwordForm.reset();
        this.passwordForm.disable();
        setTimeout(() => {
          this.successMessage = '';
          this.bsModalRef.hide();
        }, 2000);
      },
      error => {
        this.errorMessage = error;
        this.submitted = false;
      }
    );
  }

  onCloseOrCancel() {
    this.bsModalRef.hide();
    this.itemSaved.next(false);
  }

}
